import { render } from "./Elections.vue?vue&type=template&id=11ab79b3&scoped=true&ts=true"
import script from "./Elections.vue?vue&type=script&lang=ts"
export * from "./Elections.vue?vue&type=script&lang=ts"

import "./Elections.vue?vue&type=style&index=0&id=11ab79b3&scoped=true&lang=css"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ab79b3"]])

export default __exports__